import Button from '@components/v2/ui/Button/Button';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../translation/TranslationContext';

interface IChannelButton {
  label: LangEnum;
  isActive: boolean;

  handleClick: () => void;
}

const ChannelButton = ({ label, isActive, handleClick }: IChannelButton) => {
  const { translate } = useTranslation();

  return (
    <Button
      variant="contained"
      color="secondary"
      size="small"
      isActive={isActive}
      aria-selected={isActive}
      onClick={handleClick}
    >
      {translate(label)}
    </Button>
  );
};

export default ChannelButton;
